import { Component, OnInit } from '@angular/core';
import { AppIcon } from './app-icon';
import { SidebarService } from './../sidebar/sidebar.service';
import { ApiRestService } from 'src/app/services/network/api-rest.service';
import { AdminUserModule } from 'src/app/models/admin-user.model';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  adminData: AdminUserModule;
  constructor(
    public sidebarservice: SidebarService,
    private apiRestService: ApiRestService
  ) {
    if (this.theme_name == 'light_mode') {
      document
        .querySelector('html')
        .classList.replace('dark_mode', 'light_mode');
    } else if (this.theme_name == 'dark_mode') {
      document
        .querySelector('html')
        .classList.replace('light_mode', 'dark_mode');
    }
  }

  theme_name = localStorage.getItem('theme') || 'light_mode';

  toggleSearch: boolean = false;

  getThemeIcon() {
    if (this.theme_name == 'dark_mode') {
      return 'light_mode';
    } else if (this.theme_name == 'light_mode') {
      return 'dark_mode';
    } else {
      return 'dark_mode';
    }
  }

  getInitials(name: string, lastName: string): string {
    const firstInitial = name ? name.charAt(0).toUpperCase() : '';
    const lastInitial = lastName ? lastName.charAt(0).toUpperCase() : '';
    return firstInitial + lastInitial;
  }

  darkMode() {
    console.log(this.theme_name);
    if (this.theme_name == 'light_mode') {
      localStorage.setItem('theme', 'dark_mode');
      document
        .querySelector('html')
        .classList.replace('light_mode', 'dark_mode');
      this.theme_name = 'dark_mode';
    } else if (this.theme_name == 'dark_mode') {
      localStorage.setItem('theme', 'light_mode');
      document
        .querySelector('html')
        .classList.replace('dark_mode', 'light_mode');
      this.theme_name = 'light_mode';
    }
    console.log(this.theme_name);
    return this.theme_name;
  }

  getSideBarSate() {
    return this.sidebarservice.getSidebarState();
  }

  toggleSidebar() {
    this.sidebarservice.setSidebarState(!this.sidebarservice.getSidebarState());
  }

  appIcon: AppIcon[] = [
    { src: 'assets/images/app/apple.png', name: 'Apple' },
    { src: 'assets/images/app/behance.png', name: 'Behance' },
    { src: 'assets/images/app/slack.png', name: 'Slack' },
    { src: 'assets/images/app/bootstrap.png', name: 'Bootstrap' },
    { src: 'assets/images/app/google-drive.png', name: 'Drive' },
    { src: 'assets/images/app/outlook.png', name: 'Outlook' },
    { src: 'assets/images/app/github.png', name: 'GitHub' },
    { src: 'assets/images/app/stack-overflow.png', name: 'Overflow' },
    { src: 'assets/images/app/figma.png', name: 'Figma' },
    { src: 'assets/images/app/twitter.png', name: 'Twitter' },
    { src: 'assets/images/app/google-calendar.png', name: 'Calendar' },
    { src: 'assets/images/app/spotify.png', name: 'Spotify' },
    { src: 'assets/images/app/google-photos.png', name: 'Photos' },
    { src: 'assets/images/app/pinterest.png', name: 'Pinterest' },
    { src: 'assets/images/app/linkedin.png', name: 'linkedin' },
    { src: 'assets/images/app/dribble.png', name: 'Dribbble' },
    { src: 'assets/images/app/youtube.png', name: 'YouTube' },
    { src: 'assets/images/app/google.png', name: 'News' },
    { src: 'assets/images/app/envato.png', name: 'Envato' },
    { src: 'assets/images/app/safari.png', name: 'Safari' },
  ];

  ngOnInit() {
    this.adminData = this.apiRestService.getDataToken();
  }

  logOut() {
    this.apiRestService.clearExpiredSesion();
    this.apiRestService.getRouter().navigate(['/auth/login']);
  }
}
